// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.number.min-safe-integer.js
 ** module id = 1020
 ** module chunks = 1
 **/